export interface ReservadoVendidoData {
  tipoRelatorio: string;
  idRevendaEmpreendimento: string;
  idRevendaEmpreendimentoTorre: string;
  idEquipe: string;
  idResponsavel: string;
  vagas: number | null;
  areaUtil: number | null;
  periodoDe: Date | null;
  periodoAte: Date | null;
}

export const defaultRVData: ReservadoVendidoData = {
  tipoRelatorio: "R",
  idRevendaEmpreendimento: "",
  idRevendaEmpreendimentoTorre: "",
  idEquipe: "",
  idResponsavel: "",
  vagas: null,
  areaUtil: null,
  periodoDe: null,
  periodoAte: null,
};

export interface UnidadeGeralData {
  tipoRelatorio: string;
  idRevendaEmpreendimento: string;
  idRevendaEmpreendimentoTorre: string;
  cidade: string;
  bairro: string;
  idRevendaCaracteristica: string;
  numeroSuites: number | null;
  vagas: number | null;
  areaUtil: number | null;
  preco: number | null;
  status: number[];
  periodoDe: Date | null;
  periodoAte: Date | null;
}

export const defaultUGData: UnidadeGeralData = {
  tipoRelatorio: "U",
  idRevendaEmpreendimento: "",
  idRevendaEmpreendimentoTorre: "",
  cidade: "",
  bairro: "",
  idRevendaCaracteristica: "",
  numeroSuites: null,
  vagas: null,
  areaUtil: null,
  preco: null,
  status: [],
  periodoDe: null,
  periodoAte: null,
};
